<template lang="pug">
    b-modal(id="responsive-filters" hide-footer hide-header static scrollable)
      a.text-white.product-responsive-filters__close(@click.prevent="onHideModal")
        font-awesome-icon(:icon="['far', 'times']")
      .product-responsive-filters__body
        product-filters(:data-filters="filters" @updated="onFiltersUpdated" v-if="filters")
</template>

<script>
  import EventBus from "../../eventBus";
  import ProductFilters from "../../pages/shop/product/ProductFilters";

  export default {
    watch: {
      $route(val, oldVal) {
        if (val.path === oldVal.path) return;
        this.$bvModal.hide('responsive-filters');
        this.filters = false;
      }
    },
    props: {
      dataFilters: {
        type: Object,
        default: () => {
        },
      }
    },
    data() {
      return {
        filters: false
      }
    },
    components: {
      ProductFilters
    },
    mounted() {
      EventBus.$on('FILTERS_UPDATED', payLoad => {
        this.filters = { ...payLoad };
      });
    },
    methods: {
      onHideModal() {
        this.$bvModal.hide('responsive-filters');
      },
      onFiltersUpdated(filters) {
        this.onHideModal();
        EventBus.$emit('FILTERS_SELECTED', filters);
      }
    }
  }
</script>
